import React, { useEffect, useRef, useState } from 'react';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { RiDashboardFill, RiCalendarLine } from 'react-icons/ri';
import { CgProfile } from 'react-icons/cg';
import { IoIosPerson } from 'react-icons/io';
import { FiMenu } from 'react-icons/fi';
import { MdNotifications } from 'react-icons/md';
import { Link, useHistory } from 'react-router-dom';

import ImgLogo from '../../assets/logo-horizontal.png';

import { colors } from '../../styles/theme/colors';

import {
  Container,
  Content,
  DropMenuProfile,
  Header,
  MenuProfileButton,
  Notifications,
  ProfileWeb,
  ProfileGreetings,
} from './styles';
import { useAuth } from '../../hooks/auth';

interface MainTemplateProps {
  withLateralMenu: boolean;
  withHeader: boolean;
  route: string;
}

const MainTemplate: React.FC<MainTemplateProps> = ({
  withLateralMenu,
  withHeader,
  route,
  children,
}) => {
  const { signOut, name } = useAuth();
  const containerRef = useRef<HTMLDivElement>(null);
  const history = useHistory();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const onResizeEvent = () => {
    const newWidth = containerRef.current?.offsetWidth;
    if (newWidth) {
      setIsCollapsed(newWidth <= 1200);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onResizeEvent, true);

    onResizeEvent();
  }, []);

  const handleMenuItemActive = (itemValue: string[]): boolean => {
    return itemValue.includes(route);
  };

  return (
    <Container ref={containerRef} withHeader={withHeader}>
      {withHeader && (
        <Header withLateralMenu={withLateralMenu}>
          <div>
            <button type="button" onClick={() => setIsOpen(value => !value)}>
              <FiMenu color="#fff" size={25} />
            </button>
            <button
              onClick={() => history.push('/area/principal')}
              type="button"
            >
              <img src={ImgLogo} alt="logo" />
            </button>
          </div>

          {withLateralMenu && (
            <>
              <Notifications
                type="button"
                hasNewNotifications={false}
                onClick={() => history.push('/area/notificacoes')}
              >
                <MdNotifications color="#fff" size={30} />
              </Notifications>
              <ProfileWeb>
                <CgProfile color="#fff" size={30} />
                {name && (
                  <ProfileGreetings>
                    <span>Olá,</span>
                    <strong>{name.split(' ')[0]}</strong>
                  </ProfileGreetings>
                )}
                <DropMenuProfile>
                  <li>
                    <MenuProfileButton
                      onClick={() => history.push('/area/perfil')}
                    >
                      Perfil
                    </MenuProfileButton>
                  </li>
                  <li>
                    <MenuProfileButton
                      onClick={() =>
                        history.push('/area/questionarios/comorbidade')
                      }
                    >
                      Editar comorbidades
                    </MenuProfileButton>
                  </li>
                  <li>
                    <MenuProfileButton
                      onClick={() =>
                        history.push('/area/profile/alterar-senha')
                      }
                    >
                      Trocar senha
                    </MenuProfileButton>
                  </li>
                  <li>
                    <MenuProfileButton onClick={signOut}>
                      Sair
                    </MenuProfileButton>
                  </li>
                </DropMenuProfile>
              </ProfileWeb>
            </>
          )}
        </Header>
      )}
      <div>
        {isOpen && withLateralMenu && (
          <ProSidebar collapsed={isCollapsed} width="200px">
            <SidebarContent>
              <Menu iconShape="circle">
                <SubMenu
                  title="Principal"
                  icon={<RiDashboardFill color={colors.grayPrimaryDark} />}
                >
                  <MenuItem active={handleMenuItemActive(['/area/principal'])}>
                    Início
                    <Link to="/area/principal" />
                  </MenuItem>
                  <MenuItem active={handleMenuItemActive(['/area/info/covid'])}>
                    Suspeita COVID
                    <Link to="/area/info/covid" />
                  </MenuItem>
                  <MenuItem
                    active={handleMenuItemActive(['/area/listagem-ubs'])}
                  >
                    Conheça sua UBS
                    <Link to="/area/listagem-ubs" />
                  </MenuItem>
                  <MenuItem
                    active={handleMenuItemActive(['/area/informacoes-uteis'])}
                  >
                    Informações úteis
                    <Link to="/area/informacoes-uteis" />
                  </MenuItem>

                  <MenuItem
                    active={handleMenuItemActive([
                      '/area/servicos-perto-de-voce',
                    ])}
                  >
                    Serviços perto de você
                    <Link to="/area/servicos-perto-de-voce" />
                  </MenuItem>

                  <MenuItem active={handleMenuItemActive(['/area/exames'])}>
                    Exames enviados
                    <Link to="/area/exames" />
                  </MenuItem>
                </SubMenu>
                <MenuItem
                  icon={<RiCalendarLine color={colors.grayPrimaryDark} />}
                  active={handleMenuItemActive(['/area/agendamento'])}
                >
                  Telemedicina
                  <Link to="/area/agendamento" />
                </MenuItem>
                <SubMenu
                  title="Perfil"
                  icon={<IoIosPerson color={colors.grayPrimaryDark} />}
                >
                  <MenuItem
                    active={handleMenuItemActive([
                      '/area/questionarios/comorbidade',
                    ])}
                  >
                    Editar Comorbidades
                    <Link to="/area/questionarios/comorbidade" />
                  </MenuItem>
                  <MenuItem active={handleMenuItemActive(['/area/perfil'])}>
                    Detalhes
                    <Link to="/area/perfil" />
                  </MenuItem>
                  <MenuItem
                    active={handleMenuItemActive([
                      '/area/profile/alterar-senha/escolher',
                      '/area/profile/alterar-senha/verificar',
                      '/area/profile/alterar-senha/verificar/confirmar',
                    ])}
                  >
                    Trocar senha
                    <Link to="/area/profile/alterar-senha/escolher" />
                  </MenuItem>
                </SubMenu>
              </Menu>
            </SidebarContent>
          </ProSidebar>
        )}
        <Content>{children}</Content>
      </div>
    </Container>
  );
};

export default MainTemplate;
